<template>
  <!-- 悬浮框 -->
   <div class="hang">
    <ul>
      <li @mouseenter="showEmail=true" @mouseleave="showEmail=false">
        <img src="../assets/email.png" alt="">
        <span>{{ isEnglish ? 'email' : '邮箱' }}</span>

      </li>
      <div class="flo-sl">
        <transition name="slide-dropdown">
          <div class="dropdown_email" v-if="showEmail">
            <!-- <img src="../assets/dog.jpg" alt=""> -->
            <div class="re">
              <h5>business@womutech.com</h5>
            </div>
          </div>
        </transition>
      </div>
      <li @mouseenter="showTele=true" @mouseleave="showTele=false">
        <img src="../assets/tele.png" alt="">
        <span>{{ isEnglish ? 'telephone' : '电话' }}</span>

      </li>
      <div class="flo-sl">
        <transition name="slide-dropdown">
          <div class="dropdown_tele" v-if="showTele">
            <!-- <img src="../assets/dog.jpg" alt=""> -->
            <div class="re">
              <h5>400-009-1897</h5>
            </div>
          </div>
        </transition>
      </div>
      <li @mouseenter="showwechat=true" @mouseleave="showwechat=false">
        <img src="../assets/erwei.png" alt="">
        <span>{{ isEnglish ? 'QR code' : '二维码' }}</span>

      </li>
      <transition name="slide-dropdown" v-if="isEnglish">
          <div class="dropdown_wechat" v-if="showwechat">
            <div class="drop_box">
              <div class="img_box">
                <img src="../assets/erweima11.jpg" alt="">
              </div>
              <h5>Facebook</h5>
            </div>
            <div class="drop_box">
              <div class="img_box">
                <img src="../assets/erweima22.jpg" alt="">
              </div>
              <h5>WhatsApp</h5>
            </div>
          </div>
        </transition>
        <transition name="slide-dropdown" v-else>
          <div class="dropdown_wechat" v-if="showwechat">
            <div class="drop_box">
              <div class="img_box">
                <img src="../assets/erweima112.jpg" alt="">
              </div>
              <h5>{{ isEnglish ? 'Scan to follow' : '扫码关注' }}</h5>

            </div>
            <div class="drop_box">
              <div class="img_box">
                <img src="../assets/erweima222.jpg" alt="">
              </div>
              <h5>{{ isEnglish ? 'Business customer service' : '企业客服' }}</h5>

            </div>
          </div>
        </transition>
      <li class="gotop" @click="goto_top">
        <img src="../assets/arrow.png" alt="">
      </li>
    </ul>
   </div>
</template>

<script setup name="HangBox">
import { ref, computed } from 'vue';
let showEmail = ref(false);
let showTele = ref(false);
let showwechat = ref(false);
let isEnglish = ref(window.location.pathname.startsWith('/en'));

isEnglish = computed(() => {
  return window.location.pathname.startsWith('/en')
})
 function goto_top(){
    window.scrollTo(0,0);
  }
</script>

<style scoped>
/* 悬浮框 */
.el-icon{
  width: 100%;
  font-size: 20px;
  cursor: pointer;
}
.hang{
  position: fixed;
  right: 1.5em;
  top:40%;
  width: 3.5%;
  box-shadow: 0px 0px 10px 0px #ddd;
  border-radius: 30px;
  background-color: #fff;
}
.hang ul{
  width: 62%;
  margin: 2em auto;
}
.hang ul li{
  list-style:none;
  width: 100%;
  text-align: center;
  margin-top: 1em;
}
.hang ul li span{
  font-size:10px;
}
/* 进入前/离开后状态 */
.slide-dropdown-enter-from,
.slide-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 进入/离开活动状态 */
.slide-dropdown-enter-active,
.slide-dropdown-leave-active {
  transition: all 0.3s ease;
}

/* 进入后/离开前状态 */
.slide-dropdown-enter-to,
.slide-dropdown-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* 下拉菜单样式 */
.dropdown_email {
  position: absolute;
  right: 100%;
  top: 1.5em;
  background: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  /* 添加箭头样式 */
  margin-right: 10px;
}
.hang ul li img{
  width: 100%;
}
.hang ul li{
  cursor: pointer;
}
.dropdown_email::before {
  content: "";
  position: absolute;
  right: -10px;
  top: 1em;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 10px;
  border-color: transparent transparent transparent white;
}
.dropdown_tele {
  position: absolute;
  right: 100%;
  top: 5.5em;
  background: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  /* 添加箭头样式 */
  margin-right: 10px;
}

.dropdown_tele::before {
  content: "";
  position: absolute;
  right: -10px;
  top: 1em;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 10px;
  border-color: transparent transparent transparent white;
}
.dropdown_wechat {
  position: absolute;
  display: flex;
  justify-content: space-between;
  right: 100%;
  top: 5.5em;
  background: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  /* 添加箭头样式 */
  margin-right: 10px;
}
.dropdown_wechat .drop_box{
  width: 10em;
  height: 10em;
}
.dropdown_wechat .drop_box .img_box{
  width: 80%;
  height: 70%;
  margin: 1em auto;
}
.dropdown_wechat .drop_box img{
  width: 100%;
  height: 100%;
  
}
.dropdown_wechat>.drop_box>h5{
  width: 70%;
  text-align: center;
  margin:1em auto;
  background-color: #ECEEF0;
  border-radius: 1em;
}
.dropdown_wechat::before {
  content: "";
  position: absolute;
  right: -10px;
  top: 5em;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}
.re h5{
  width: 18em;
  text-align: center;
}
.dropdown>img {
  width: 30em;
}
</style>